import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  MagicLinkResponse,
  MagicLinkVerifyRequest,
  TokenResponse,
} from '../models/coverage-validator-api-models';

// Errors are left as HttpErrorResponse: the store maps 404/410/429/401 to what the page shows.
@Injectable({
  providedIn: 'root',
})
export class MagicLinkService {
  private http = inject(HttpClient);

  // A saved insured token comes back as isVerified when it belongs to this link's inspection.
  getLink(linkId: string): Promise<MagicLinkResponse> {
    return firstValueFrom(this.http.get<MagicLinkResponse>(`magic-link/${linkId}`));
  }

  sendCode(linkId: string): Promise<void> {
    return firstValueFrom(this.http.post<void>(`magic-link/${linkId}/code`, null));
  }

  verifyCode(linkId: string, code: string): Promise<TokenResponse> {
    const request: MagicLinkVerifyRequest = { code };
    return firstValueFrom(this.http.post<TokenResponse>(`magic-link/${linkId}/verify`, request));
  }
}
